import React from "react";

import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";
import {ValidateStep0Data} from "@validators/motor-cycle-insurance-form/step0-validator";
import NextButtonComponent from "@components/common/form-controls/buttons/next-button";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";
import {showValidationErrorsModal} from "@utils/modal-manager";
import {DISCOVERY_TYPES_REQUIRES_REFERRER_OPTIONS} from "@constants/dropdown-choices";
import {DISCOVERY_TYPES_MOTOR_CYCLE} from "@constants/dropdown-choices";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import {WizardStepButtonsBlock} from "@components/common/form-blocks/other/wizard-step-buttons-block";


export default function IF_Step0(
    {
        data,
        handlers,
        setCurrentStep
    }
) {

    function onNextBtnClick() {

        let validationResult = ValidateStep0Data(data);

        if (validationResult.length > 0) {

            showValidationErrorsModal({
                validationResult: validationResult
            })

        } else {
            setCurrentStep(1);
        }


    }

    return (
        <div className={'if-step-0'}>

            <div className="row">

                {/* Discount code, if any */}

                <ScrollableTextBoxBlock
                    containerCssClass="col-12 py-3 "
                    labelText="Discount code, if any"
                    required={false}
                    controlName="discountCode"
                    value={data.discountCode}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />

                <ScrollableDropdownBlock
                    controlName="discoveryType"
                    containerCssClass="col-12 py-3"
                    dataBlock="discoveryType"
                    controlId="discoveryType"
                    labelText="How did you hear about us?"
                    required={true}
                    options={DISCOVERY_TYPES_MOTOR_CYCLE}
                    selectedValues={data.discoveryType}
                    onChange={handlers.onControlChange}
                    helpText={`Registered with the ICO, all your personal information is protected under the Data Protection Act 2018`}
                />

                {DISCOVERY_TYPES_REQUIRES_REFERRER_OPTIONS.includes(data.discoveryType) && (

                    <>
                        {/* Referrer's name */}

                        <ScrollableTextBoxBlock
                            containerCssClass="col-12 py-3 "
                            labelText="Referrer's name"
                           // required={DISCOVERY_TYPES_REQUIRES_REFERRER_OPTIONS.includes(data.discoveryType)}
                            controlName="referrersName"
                            value={data.referrersName}
                            onChange={handlers.onControlChange}
                            inputAttrs={{
                                maxLength: 50
                            }}
                        />

                    </>

                )}

            </div>

            <SectionHeading
                text="Contact details"
            />

            <div className="row contact-block">

                {/* Contact email */}

                <ScrollableTextBoxBlock
                    type="email"
                    containerCssClass="col-12 py-3 col-md-6"
                    labelText="Contact email"
                    required={true}
                    controlName="contactEmail"
                    value={data.contactEmail}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />


                {/* Contact phone */}

                <ScrollableTextBoxBlock
                    type="tel"
                    containerCssClass="col-12 py-3 col-md-6"
                    labelText="Contact phone"
                    required={true}
                    controlName="contactPhone"
                    value={data.contactPhone}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />

            </div>

           
           <WizardStepButtonsBlock
              onNextBtnClick={onNextBtnClick}
              showPrevBtn={false}
           />


        </div>
    )
}